import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.wgsl = bracketIndenting()
